import { Reveal } from "./Reveal";

const chapters = [
  {
    number: "01",
    title: "Obbligo normativo",
    text: "L'abilitazione SAB è obbligatoria per legge per chi apre o gestisce attività di somministrazione e vendita di alimenti e bevande.",
  },
  {
    number: "02",
    title: "Programma 130 ore",
    text: "Due macro aree: gestione d'impresa, fiscale e commerciale; merceologia, igiene e sicurezza alimentare HACCP.",
  },
  {
    number: "03",
    title: "Flessibilità formativa",
    text: "Scegli tu come frequentare: in presenza nella sede di Milano in Via Mazzali 5, oppure online in modalità FAD.",
  },
  {
    number: "04",
    title: "Abilitazione nazionale",
    text: "Superi l'esame finale davanti alla Commissione e ottieni l'attestato di abilitazione valido su tutto il territorio italiano.",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-paper py-16 md:py-24" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {chapters.map((c, i) => (
            <Reveal key={c.number} delay={i * 0.1}>
              <div
                className="group h-full border border-line bg-white p-7 transition-colors duration-300 hover:bg-navy"
                data-testid={`manifesto-chapter-${c.number}`}
              >
                <span className="font-mono text-sm font-medium text-brand-amber">{c.number}</span>
                <h3 className="mt-5 font-heading text-xl font-bold tracking-tight text-navy transition-colors group-hover:text-white">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 transition-colors group-hover:text-slate-300">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
